<!-- <div class="chart-title">{{chartData.title}}</div>
<canvas id="chart"></canvas> -->
<div class="chart-wrapper">
  <canvas baseChart height="400" width="560" [datasets]="barChartData" [labels]="barChartLabels"
    [options]="barChartOptions" [colors]="barChartColors" [plugins]="barChartPlugins" [legend]="barChartLegend"
    [chartType]="barChartType">
  </canvas>
</div>
